var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topBarItem",class:{ 'right' : _vm.right}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.icon)?_c('chevron-down-icon',{staticClass:"icon"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }